import { render, staticRenderFns } from "./TabsChattingRoom.vue?vue&type=template&id=df8395b0&scoped=true&"
import script from "./TabsChattingRoom.vue?vue&type=script&lang=js&"
export * from "./TabsChattingRoom.vue?vue&type=script&lang=js&"
import style0 from "./TabsChattingRoom.vue?vue&type=style&index=0&id=df8395b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8395b0",
  null
  
)

export default component.exports